import axios from '@/libs/api.request'

export const getLaborcompanylist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/laborcompany/laborcompany/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationLaborcompany = (data, meth) => {
  return axios.request({
    url: '/v1/laborcompany/laborcompany/',
    method: meth,
    data
  })
}